import React, { createContext, useState, useEffect } from "react";
import { getMethod } from "./Service"; // Adjust this path if needed
import { APIENDPOINTS } from "../Api/Api";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  // Persist user data from localStorage
  const [userData, setUserData] = useState(() => {
    const local = localStorage.getItem("user");
    return local ? JSON.parse(local) : null;
  });

  // Cart data from localStorage
  const [cartItems, setCartItems] = useState(() => {
    const savedCart = localStorage.getItem("cartItems");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  // Other product-related states
  const [filteredProductsbyOccuptionType, setFilteredProductsbyOccuptionType] =
    useState([]);
  const [newarrival, setNewarrival] = useState([]);
  const [categoyrProducts, setCategoyrProducts] = useState([]);

  const userId =
    userData?.data?._id || JSON.parse(localStorage.getItem("user"))?._id;

  // Add items to cart and update local state
  const addToCart = (item) => {
    const exists = cartItems.find((i) => i.item_id === item.item_id);
    if (exists) {
      const updated = cartItems.map((i) =>
        i.item_id === item.item_id
          ? { ...i, quantity: i.quantity + item.quantity }
          : i
      );
      setCartItems(updated);
    } else {
      setCartItems([...cartItems, item]);
    }
  };

  // Sync cartItems to localStorage on every change
  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  return (
    <UserContext.Provider
      value={{
        userData,
        setUserData,
        filteredProductsbyOccuptionType,
        setFilteredProductsbyOccuptionType,
        newarrival,
        setNewarrival,
        categoyrProducts,
        setCategoyrProducts,
        cartItems,
        setCartItems,
        addToCart,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
